import { render, staticRenderFns } from "./profileFriend.vue?vue&type=template&id=d1d2d702"
import script from "./profileFriend.vue?vue&type=script&lang=js"
export * from "./profileFriend.vue?vue&type=script&lang=js"
import style0 from "./profileFriend.vue?vue&type=style&index=0&id=d1d2d702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports